<div class="a-select"
  [class.gray-bg]="grayBg"
  [class.is-optional]="isOptional"
  [class.has-select]="selectedItem">

  <notify-popup
    *ngIf="savedValue && enableJobTitleWarnity"
    (onChanged)="clearConfirm($event)"
    [okLabel]="'ASelect.Yes' | translate"
    [msg]="'ASelect.ChangeProfessionWarning' | translate">
  </notify-popup>

  <div class="a-select__optional" *ngIf="isOptional">{{ 'ASelect.Optional' | translate }}</div>

  <div class="a-select__inner" 
    [class.has-value]="control.value"
    [class.is-disabled]="isDisabled"
    [class.has-error]="control.invalid && isSubmitted">

    <div class="a-select__select" #selectEl
      *ngIf="!enableSearch"
      [class.is-default]="!selectedItem" 
      (click)="showDropdown($event)">
      <span class="a-select__select__label" *ngIf="selectedItem">{{ label }}</span>
      <span>{{ selectedItem ? useLables ? selectedItem.label : selectedItem[valueKey] : label }}</span>
        <span class="a-select__meta-tag" *ngIf="selectedItem && hasMeta && selectedItem.meta">{{ selectedItem.meta
        }}</span>
      <i class="app-ico-mask app-ico-mask__x" *ngIf="hasClear && control.value" (click)="clear()"></i>
      <i class="app-ico-mask app-ico-mask__select-arrow-down" [class.is-open]="showItems"></i>
    </div>
    
    <div class="a-select__items-bg" *ngIf="allItems && allItems.length && showItems" (click)="showDropdown($event, false)"></div>
    <div class="a-select__items" @slideInOut
      *ngIf="allItems && allItems.length && showItems" 
      [class.open-top]="openPositionTop">
      <div class="a-select__items-inner is-scroll" #scrolledEl>
        <div class="a-select__item"
          *ngFor="let item of shadowItems; let i = index;" 
          [id]="'a-select-item-id-' + i"
          [class.active]="selectedItem ? item[valueKey] === selectedItem[valueKey] : ''"
          (click)="selectItem(item, enableJobTitleWarnity, true);">
          {{ useLables ? item.label : item[valueKey] }}
        </div>
      </div>
      <div class="a-select__items__nothing" *ngIf="!shadowItems.length && enableSearch">
        {{ 'ASelect.NothingFound' | translate }}
      </div>
    </div>

    <div class="a-select__input-box" *ngIf="enableSearch">
      <input #selectEl
        placeholder=" "
        type="text"
        [disabled]="isDisabled"
        [class.has-clear]="hasClear && control.value"
        [ngModel]="searchValue" 
        (ngModelChange)="findResult($event)"
        (focus)="onFocus(true)" 
        (blur)="onFocus(false)">
      <label>{{ label }}</label>
      <i class="app-ico-mask app-ico-mask__x"
        *ngIf="hasClear && control.value"
        (mousedown)="$event.preventDefault()"
        (click)="clear()">
      </i>
      <i class="app-ico-mask app-ico-mask__select-arrow-down" 
        [class.is-open]="showItems"
        (click)="showDropdown($event, showItems ? false : true)">
      </i>
    </div>
  </div>
  

</div>